import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import ReportProductCustomerSummaryMain from "../../../features/report/report-product-customer-summary/component/report-product-customer-summary-main";

const title = "Report Product Customer Summary";

const ReportProductCustomerSummaryPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ReportProductCustomerSummaryMain />;
};

export default ReportProductCustomerSummaryPage;
